
import './wdk_install_pop.scss';
import { nxtInstallCall  } from '../../apicall';
const { __ } = wp.i18n;
import { useState } from 'react';

const WdkInstallPopup = ({ isWDKPopupVisible, setIsWDKPopupVisible }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const wdkit_poup_accordian = [
        { question: __('Why Do I Need to Install WDesignKit If I Already Have Nexter Blocks?', 'nexter-extension'), answer: __('Using WDesignKit you will get access of extra Gutenberg Blocks, which is not part of Nexter Blocks. Those blocks built from Block Builder of WDesignKit and You can edit them from our Easy to Use Gutenberg Block Builder as well.', 'nexter-extension') },
        { question: __('Why Can’t These Blocks Be Part of Nexter Blocks?', 'nexter-extension'), answer: __('We designed Nexter Blocks to focus on essential and core blocks that are required for most websites. WDesignKit, on the other hand, is a library with specialized creative blocks. You can download only those you want to use in WDesignKit.', 'nexter-extension') },
        { question: __('Will the Blocks Remain If I Remove WDesignKit?', 'nexter-extension'), answer: __('No, the Blocks will be removed if you delete WDesignKit, as it is required for blocks used from WDesignKit.', 'nexter-extension') },
        { question: __('Will This Affect My Website Performance?', 'nexter-extension'), answer: __('Not at all. Performance is our priority. WDesignKit will load assets of only blocks you downloaded and used on on that page. No extra assets will be loaded ever.', 'nexter-extension') }
    ];

    const WdkAccordian = (index) => {
        setActiveIndex(activeIndex === index ? null : index);

    };

    const checkSVG = (<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="none" viewBox="0 0 11 10"><path fill="#020202" d="M5.5 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm1.767 3.47L4.875 5.868 3.712 4.705a.417.417 0 0 0-.59.59L4.58 6.753a.417.417 0 0 0 .59 0l2.687-2.695a.417.417 0 0 0-.59-.588Z"/></svg>); 

    const Install_wdk = () => {
        return (
            <span>
                <div className="nxt-popup-content">
                    <div className="nxt-popup-title">{__('Get Access to 50+ More Unique Gutenberg Blocks from WDesignKit', 'nexter-extension')}</div>
                    <div className="nxt-features-dic">
                        <ul>
                            <li>
                                <span>{checkSVG}</span>
                                <span>{__('Get Access to 1000+ WordPress Templates', 'nexter-extension')}</span>
                            </li>
                            <li>
                                <span>{checkSVG}</span>
                                <span>{__('50+ Unique Gutenberg Blocks', 'nexter-extension')}</span>
                            </li>
                            <li>
                                <span>{checkSVG}</span>
                                <span>{__('Custom Gutenberg Block Builder', 'nexter-extension')}</span>
                            </li>
                            <li>
                                <span>{checkSVG}</span>
                                <span>{__('100% Customizable Blocks', 'nexter-extension')}</span>
                            </li>
                        </ul>
                    </div>
                    <div className="nxt-install-activate">
                        <a className='nxt-install-btn' onClick={(e) => (nxtInstallCall(e, true,'wdesignkit') )}>{__('Enable Blocks', 'nexter-extension')}</a>
                        <a className='nxt-learn-more' href='https://wdesignkit.com/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings' target='_blank' rel="noopener noreferrer">{__('Learn More', 'nexter-extension')}</a>
                    </div>
                    <div className="nxt-popup-accordion">
                        {wdkit_poup_accordian.map((item, index) => (
                            <div key={index} className="nxt-accordion-item">
                                <div className={`nxt-accordio-content ${activeIndex === index ? "nxt-content-opan" : ""}`} onClick={() => WdkAccordian(index)}>
                                    <div className="nxt-accd-qui">{item.question}</div>
                                    <div>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="#020202" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                            <path d="M4.16797 10H15.8346" stroke="#020202" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div className={`nxt-accd-ans ${activeIndex === index ? "opan-accordion" : ""}`}>{item.answer}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </span>
        );
    };

    return (
        <>
            <div className='nxt-wdkit-popup' onClick={(e) => e.stopPropagation()}>
                <div className='nxt-content-bg'>
                    <div className="nxt-popup-close" onClick={() => setIsWDKPopupVisible(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="gray" d="M15.393 3.725a.625.625 0 1 1 .883.884L10.885 10l5.391 5.392.044.047a.625.625 0 0 1-.88.88l-.047-.044L10 10.884 4.61 16.275a.625.625 0 0 1-.884-.883L9.117 10 3.726 4.609a.625.625 0 1 1 .884-.884L10 9.116l5.392-5.391Z"/></svg>
                    </div>
                    <div className='nxt-popup-wdk-body'>
                        {Install_wdk()}
                    </div>
                </div>
            </div> 
        </>
    );
};

export default WdkInstallPopup;